import styled from "styled-components";

export const TopInitials = styled.span`
    margin-right: 16px;
`;
